import application from 'application/application';

import moment from 'moment';

const controller = 'DefaultMovementsInssDetailsController';

application.controller(controller, [
	'$scope',
	'$rootScope',
	'$http',
	'$state',
	'$stateParams',
	'$timeout',
	'API',
	'helper',
	'notification',
	'authentication',
	'permissions',
	// 'environment',
	// 'googleAPI',
	'downloadService',
	'integracaoGoogleCalendar', //aqui google agenda
	'$location',
	(
		$scope,
		$rootScope,
		$http,
		$state,
		$stateParams,
		$timeout,
		API,
		helper,
		notification,
		authentication,
		permissions,
		// environment,
		// googleAPI,
		downloadService,
		integracaoGoogleCalendar, //aqui google agenda
		$location
	) => {
		$scope.TEST_EMPTY_LIST = false;
		$scope.TEST_MULTIPLE_ITENS = true;
		$scope.TEST_HAS_LINKED_DEADLINES = 1;

		$scope.permissionGoogleCalendar = false;

		$scope.quickToggle = true;

		const dataSyncGoogle = integracaoGoogleCalendar.recoverInfos();

		$rootScope.noSync =
			dataSyncGoogle && dataSyncGoogle.sincronizado ? false : true;

		$scope.showAgain = localStorage.getItem('showSyncMessage') || true;

		// Data do dia em cadastrar prazo
		let defaultEmptyData = {
			_dia: moment().format('DD/MM/YYYY')
		};

		$rootScope.formCreatePrazo.taskToEdit = helper.cloneSimpleObject(
			defaultEmptyData
		);
		// list of agendas
		$scope.agendas = helper.responseStore();
		// list of event types
		$scope.eventsTypes = helper.responseStore();
		$scope.eventsNotifications = helper.responseStore();

		$scope.selectedType = null;

		// list of recurring types
		$scope.recurringEventTypes = helper.responseStore();

		// list of agenda reminder types
		$scope.agendaReminderTypes = helper.responseStore();

		$scope.stateParams = $.extend({}, $stateParams);

		$scope.listEmpty = false;
		$scope.movements = {
			items: [],
			isReady: false
		};
		$scope.numeroProcesso = '';
		$scope.idProcesso = '';

		$scope.objetosExibidos = [];

		$scope.send = false;
		$scope.printing = false;

		$scope.itemCheckedDisabled = true;

		$scope.selectAllPublicationsChecked = false;

		$scope.newPublicationChecked = [];

		$scope.nextItem = null;
		$scope.prevItem = null;

		$scope.movementsInss = JSON.parse(sessionStorage.getItem('movementsINSS'));
		if (!$scope.movementsInss || $scope.movementsInss == null) {
			$scope.movementInss = undefined;
		}

		if ($scope.movementInss && $scope.movementInss != null) {
			$scope.movementsInss.paginacao = [];
			$scope.movementsInss.paginacao.push(
				JSON.parse(sessionStorage.getItem('page-movementsINSS'))
			);
		}

		$scope.groupUserSelected = localStorage.getItem('__groupSelected__');

		$scope.groupData = JSON.parse(localStorage.getItem('__groupUserData__'));

		permissions.loadPermissions().then(() => {
			$scope.schedulePermission = permissions.has('recordSchedule');
			$scope.processPermission = permissions.has('createMovements');
			$scope.automaticSearchPermission = permissions.has(
				'processesWithAutomaticMovementsSearch'
			);
		});

		$scope.pagination = {
			totalItens: 3
		};

		$scope.isMobile = false;

		$scope.shouldDeleteDeadlineType = 'andamento'; // publicação, andamento
		$scope.shouldDeleteDeadlineOption = 1;

		$scope.deleteMultiple = false;

		if (!$scope.stateParams.movements) history.back();

		$scope.onInit = () => {
			let getEventsNotifications = sessionStorage.getItem(
				'__EVENTS_NOTIFICATIONS__'
			);

			if (getEventsNotifications) {
				let eventsNotificationsTypes = JSON.parse(
					getEventsNotifications || '[]'
				);

				if (eventsNotificationsTypes && eventsNotificationsTypes.length > 1) {
					$scope.eventsNotifications.setItems(eventsNotificationsTypes);
					$scope.eventsNotifications.setReady(true);
				}
			} else {
				$scope.fetchDeadlineNotification();
			}
		};

		$scope.fetchDeadlineNotification = async () => {
			await $rootScope.fetchDeadlineNotificationId();

			let getEventsNotifications = sessionStorage.getItem(
				'__EVENTS_NOTIFICATIONS__'
			);

			if (getEventsNotifications) {
				let eventsNotificationsTypes = JSON.parse(
					getEventsNotifications || '[]'
				);

				if (eventsNotificationsTypes && eventsNotificationsTypes.length > 1) {
					$scope.eventsNotifications.setItems(eventsNotificationsTypes);
					$scope.eventsNotifications.setReady(true);
				}
			}
		};

		$scope.fetchProcessHeader = () => {
			$rootScope.creationEventLoading = true;

			if ($scope.pasta) {
				const params = {
					IdClienteXFontePesqProc: $scope.pasta
				};

				$http({
					...helper.http(API.inssProcessHeader, 'detail'),
					method: 'GET',
					params
				})
					.then(response => {
						const data = response.data;

						if (data && data.status.codigo == 200) {
							$scope.inssProcessHeader = data.itens[0];
						}
					})
					.finally(() => {
						$rootScope.creationEventLoading = false;
					});
			}
		};

		$scope.fetchDetails = () => {
			$scope.isMobile =
				window && window.innerWidth && window.innerWidth <= 991 ? true : false;

			const registros =
				$scope.stateParams.movements && $scope.stateParams.movements.split(',');

			const urlParams = $location.$$url.split('?')[1];

			if (urlParams) {
				const pages = urlParams.split('&');

				pages.forEach(page => {
					const parameter = page.split('=');

					if (parameter[0] && parameter[1] && parameter[0] == 'pasta') {
						$scope.pasta = parameter[1];

						$scope.fetchProcessHeader();
					}

					if (
						parameter[0] &&
						parameter[1] &&
						parameter[0] == 'numeroProcesso'
					) {
						$scope.numeroProcesso = parameter[1];
					}

					if (parameter[0] && parameter[1] && parameter[0] == 'idProcesso') {
						$scope.idProcesso = parameter[1];
					}

					if (parameter[0] && parameter[1] && parameter[0] == 'pastaProcesso') {
						$scope.pastaProcesso = parameter[1];
					}
				});
			}

			if (!registros || registros.length == 0) {
				history.back();
			}

			const IdsMovProcUsuarioCliente = $scope.formatArrayIntoString(registros);

			$scope.totalRegisters = registros.length;

			if (
				$scope.stateParams &&
				$scope.stateParams.titulo &&
				$scope.stateParams.titulo.length > 2
			) {
				$scope.searchIcon = false;
				$scope.verifySearch = true;
			} else {
				$scope.searchIcon = true;
			}

			if (registros.length == 1) {
				$scope.markMovementAsReadOrUnread(registros, true);
			}

			const setMovementDetails = items => {
				$scope.movements = {
					items,
					isReady: true
				};

				const now = new Date();

				for (let j = 0; j < items.length; j++) {
					const item = items[j];
					const prazos = item.prazos || [];

					prazos.sort(rearrangeDeadline);

					for (let i = 0; i < prazos.length; i++) {
						const p = prazos[i];

						if (!p || !p.dataHoraInicio) continue;
						const prazo = new Date(p.dataHoraInicio);

						if (isNaN(prazo.getTime())) continue;

						if (p.concluido) continue;

						if (p.diaInteiro) {
							const prazoDia = new Date(
								prazo.getFullYear(),
								prazo.getMonth(),
								prazo.getDate(),
								23,
								59,
								59,
								999
							);

							if (prazoDia > now) {
								item.prazosAvencer = true;
							} else {
								item.prazosVencido = true;
							}
						} else {
							if (prazo < now) item.prazosVencido = true;
							if (prazo > now) item.prazosAvencer = true;
						}

						if (item.prazosVencido && item.prazosAvencer) break;
					}

					$scope.displayDeadlines(prazos);
				}
			};

			$http({
				...helper.http(API.inssMovementsDetails, 'GET'),
				method: 'GET',
				params: {
					...helper.httpFields(['*']),
					IdsMovProcUsuarioCliente,
					PaginaAtual: 1,
					RegistrosPorPagina: 100,
					Ordenacao: 'UltimoMovimento',
					idGrupoUsuarios:
						$scope.groupUserSelected && $scope.groupData
							? $scope.groupData.idGrupo
							: null,
					pesquisa:
						$scope.stateParams &&
						$scope.stateParams.titulo &&
						$scope.stateParams.titulo.length > 2
							? $scope.stateParams.titulo
							: null
				}
			}).then(response => {
				const items = response.data.itens || [];

				if (items.length || !$scope.stateParams.pasta) {
					setMovementDetails(items);

					return;
				}

				$http({
					...helper.http(API.sourceAccessData, 'movements'),
					method: 'GET',
					params: {
						idClienteXFontePesqProc: $scope.stateParams.pasta,
						PaginaAtual: 1,
						RegistrosPorPagina: 100,
						Ordenacao: 'UltimoMovimento',
						idGrupoUsuarios:
							$scope.groupUserSelected && $scope.groupData
								? $scope.groupData.idGrupo
								: null
					}
				}).then(fallbackResponse => {
					const fallbackItems = fallbackResponse.data.itens || [];
					const movementId = String(registros[0]);
					const movement = fallbackItems.find(
						item => String(item.idMovProcUsuarioCliente) === movementId
					);

					setMovementDetails(movement ? [movement] : []);
				});
			});
		};

		$scope.selectAllPublications = movements => {
			$scope.newPublicationChecked = [];

			if ($scope.stateParams.pasta) var itemsToUpdate = movements.items;

			if (movements.items.length == 0) {
				return;
			}

			if (!$scope.idCheckboxAllDetails) {
				$('#movement-checkbox-all_details').prop('checked', false);
				$scope.idCheckboxAllDetails = true;
			} else {
				$('#movement-checkbox-all_details').prop('checked', true);
				$scope.idCheckboxAllDetails = false;
			}

			if (
				$('#movement-checkbox-all_details').prop('indeterminate') ||
				!$('#movement-checkbox-all_details').prop('checked')
			) {
				itemsToUpdate.forEach(item => {
					item.__checked__ = true;
					$scope.newPublicationChecked.push(item);
				});

				$('#movement-checkbox-all_details').prop('indeterminate', false);
				$('#movement-checkbox-all_details').prop('checked', true);
			} else {
				itemsToUpdate.forEach(item => {
					item.__checked__ = false;
					$scope.newPublicationChecked = $scope.newPublicationChecked.filter(
						value => item.idMovProcessoCliente !== value.idMovProcessoCliente
					);
				});
				$('#movement-checkbox-all_details').prop('indeterminate', false);
				$('#movement-checkbox-all_details').prop('checked', false);
			}

			const checked = $scope.newPublicationChecked;

			if (!checked || checked.length < 2) $scope.itemCheckedDisabled = true;
			else $scope.itemCheckedDisabled = false;
		};

		$scope.selectPublication = item => {
			$scope.newPublicationChecked = $scope.newPublicationChecked
				? $scope.newPublicationChecked
				: [];
			if (item.__checked__ === true) {
				$scope.newPublicationChecked.push(item);
			} else {
				$scope.newPublicationChecked = $scope.newPublicationChecked.filter(
					value => item.idMovProcessoCliente !== value.idMovProcessoCliente
				);
			}

			let hasTrue = false;
			let hasFalse = false;

			if ($scope.stateParams.pasta) {
				hasTrue = $scope.movements.items.some(item => item.__checked__);
				hasFalse = $scope.movements.items.some(item => !item.__checked__);
			}

			if (hasTrue) {
				if (hasFalse) {
					$('#movement-checkbox-all_details').prop('indeterminate', true);
					$('#movement-checkbox-all_details').prop('checked', false);
					$scope.allSelected = false;
				} else {
					$('#movement-checkbox-all_details').prop('indeterminate', false);
					$('#movement-checkbox-all_details').prop('checked', true);
					$scope.allSelected = true;
				}
			} else if (hasFalse) {
				$('#movement-checkbox-all_details').prop('indeterminate', false);
				$('#movement-checkbox-all_details').prop('checked', false);
			}

			const checked = $scope.newPublicationChecked;

			if (!checked || checked.length < 2) $scope.itemCheckedDisabled = true;
			else $scope.itemCheckedDisabled = false;
		};

		$scope.setPrevNextItem = () => {
			const currentIndex = $scope.getCurrentSubpoenaIndex($scope.movementsInss);

			if (currentIndex + 1 < $scope.movementsInss.length)
				$scope.nextItem = $scope.movementsInss[currentIndex + 1];

			if (currentIndex > 0)
				$scope.prevItem = $scope.movementsInss[currentIndex - 1];
		};

		$scope.getCurrentSubpoenaIndex = movements => {
			return movements.findIndex(
				movement =>
					movement.idMovProcUsuarioCliente == $scope.stateParams.movements
			);
		};

		$scope.getPaginationItemUrlMovementsINSS = item =>
			`root.default.movements.inssDetails({movements: ${item.idMovProcUsuarioCliente} })`;

		$scope.goBackMov = (param, markRead) => {
			let params = helper.cloneSimpleObject($stateParams);

			if (param && params.readStatus) {
				$('#modalToggleAsReadAll').modal('show');

				return;
			}

			$('#modalToggleAsReadAll').modal('hide');

			if (markRead) {
				const registros = $scope.stateParams.movements.split(',');

				$scope.markMovementAsReadOrUnread(registros, true);
			}

			let newParams = {};

			if ($scope.numeroProcesso) {
				newParams.numeroProcesso = $scope.numeroProcesso;
			}

			if ($scope.idProcesso) {
				newParams.idProcesso = $scope.idProcesso;
			}

			if ($scope.pastaProcesso) {
				newParams.pastaProcesso = $scope.pastaProcesso;
			}

			if (params.pasta) {
				$state.go(
					'root.default.movements.inss1',
					{ processId: params.pasta, ...newParams },
					{
						inherit: false,
						reload: true
					}
				);
			} else {
				$state.go('root.default.movements.inss', params, {
					inherit: false,
					reload: 'root.default.movements.inss'
				});
			}
		};

		$scope.markMovementAsReadOrUnread = (registros, read) => {
			const readStatus = read ? 'READ' : 'UNREAD';

			$http({
				...helper.http(API.inssUpdateReadStatus, readStatus),
				method: 'PUT',
				data: {
					idsMovProcUsuarioCliente: registros
				},
				messageOverride: {
					success(response, notify) {
						if (readStatus == 'UNREAD') {
							notify.success('Os movimentos foram marcados como não lidos.');
							$scope.goBackMov();
						}
						if (readStatus == 'READ' && registros.length > 1) {
							notify.success(response.data.status.mensagem);
						}
					},
					error(response, notify) {
						if (readStatus == 'UNREAD') {
							notify.success(
								'Houve um problema ao marcar os movimentos como não lidos.'
							);
						}
						if (readStatus == 'READ' && registros.length > 1) {
							notify.danger(response.data.status.mensagem);
						}
					}
				}
			})
				.then(response => {
					if (response.data.itens.length) $scope.setPrevNextItem();
				})
				.catch(error => {
					return error;
				});
		};

		$scope.sendToTrashCan = (movements, request) => {
			if ($scope.restore || $scope.send) return;

			request == 'restore' ? ($scope.restore = true) : ($scope.send = true);

			let objData = [];

			if (movements && movements.items) {
				movements.items.forEach(item => {
					objData.push({
						idPasta:
							item.idPasta ||
							item.idPastaUsuarioCliente ||
							$scope.pastaProcesso,
						idMovimentoProcessoCliente: item.idMovProcessoCliente,
						idUsuarioCliente: item.idUsuarioCliente,
						idGrupoUsuarios:
							$scope.groupUserSelected && $scope.groupData
								? $scope.groupData.idGrupo
								: null,
						excluirPrazosVinculados:
							item.prazos &&
							item.prazos.length > 0 &&
							$scope.shouldDeleteDeadlineOption == 2
					});
				});

				var movementsItems = true;
			} else if (movements) {
				if (movements.length > 0) {
					movements.forEach(item => {
						objData.push({
							idPasta:
								item.idPasta ||
								item.idPastaUsuarioCliente ||
								$scope.pastaProcesso,
							idMovimentoProcessoCliente: item.idMovProcessoCliente,
							idUsuarioCliente: item.idUsuarioCliente,
							idGrupoUsuarios:
								$scope.groupUserSelected && $scope.groupData
									? $scope.groupData.idGrupo
									: null,
							excluirPrazosVinculados:
								item.prazos &&
								item.prazos.length > 0 &&
								$scope.shouldDeleteDeadlineOption == 2
						});
					});

					if (movements.length === $scope.movements.items.length)
						var movementsItems = true;
				} else {
					objData.push({
						idPasta:
							movements.idPasta ||
							movements.idPastaUsuarioCliente ||
							$scope.pastaProcesso,
						idMovimentoProcessoCliente: movements.idMovProcessoCliente,
						idUsuarioCliente: movements.idUsuarioCliente,
						idGrupoUsuarios:
							$scope.groupUserSelected && $scope.groupData
								? $scope.groupData.idGrupo
								: null,
						excluirPrazosVinculados:
							movements &&
							movements.prazos &&
							movements.prazos.length > 0 &&
							$scope.shouldDeleteDeadlineOption == 2
					});
				}
			}

			if (objData.length > 0) {
				$http({
					...helper.http(API.trashCan, `${request}`),
					method: 'PUT',
					data: objData,
					messageOverride: {
						success(response, notify) {
							const success =
								request == 'send'
									? 'Enviado para a Lixeira!'
									: 'Documento restaurado!';

							notify.success(success);
						},
						error(response, notify) {
							const error =
								request == 'send'
									? 'Erro ao enviar para Lixeira.'
									: 'Erro ao restaurar documento.';

							notify.danger(error);
						}
					}
				})
					.then(response => {
						if (response.status != 500) {
							if (response.status == 200) {
								if (!movementsItems) {
									let params = helper.cloneSimpleObject($stateParams);

									$state.go(
										'root.default.movements.inssDetails',
										{
											movements: params.movements,
											pasta: params.pasta,
											idProcesso: params.idProcesso,
											numeroProcesso: params.numeroProcesso,
											pastaProcesso: params.pastaProcesso
										},
										{
											inherit: false,
											reload: true
										}
									);
								} else {
									let params = helper.cloneSimpleObject($stateParams);

									$state.go(
										'root.default.movements.inss1',
										{
											processId: params.pasta,
											movements: params.movements,
											pasta: params.pasta,
											idProcesso: params.idProcesso,
											numeroProcesso: params.numeroProcesso,
											pastaProcesso: params.pastaProcesso
										},
										{
											inherit: false,
											reload: true
										}
									);
								}
							}
						} else if (response.status == 500) {
							request == 'send' &&
								notification.danger('Erro ao enviar para Lixeira.');
						}
					})
					.finally(() => {
						$scope.newPublicationChecked = [];
						$scope.idCheckboxAllDetails = false;
						$('#movement-checkbox-all_details').prop('indeterminate', false);
						$('#movement-checkbox-all_details').prop('checked', false);
						$scope.itemCheckedDisabled = true;
						$scope.send = false;
						$('#modalDeleteMovementNew').modal('hide');
						$('#modalDeleteMovementNewAll').modal('hide');
						$('#modalDeleteMovementWithDeadline').modal('hide');
					});
			}
		};

		/* Integração de Ações */

		$scope.openDeleteModal = movement => {
			if (
				$rootScope.hasGroupUserPermission === false ||
				$rootScope.hasGroupUserPermission === null
			) {
				$('#modalNotPermitted').modal('show');

				return;
			}

			$scope.movementInAction = movement;

			$rootScope.getDaysDeleteTrash();

			let el = $('#modalDeleteMovementNew');

			if (movement && movement.items && movement.items.length > 0) {
				for (let i = 0; i < movement.items.length; i++) {
					if (movement.items[i].prazos && movement.items[i].prazos.length > 0) {
						el = $('#modalDeleteMovementWithDeadline');
					}
				}

				if (movement.items.length > 1) {
					$scope.deleteMultiple = true;
				} else {
					$scope.deleteMultiple = false;
				}
			}

			el.modal && el.modal('show');
		};

		$scope.openGenericModal = (movement, id, action, fn = () => {}) => {
			if (action) $scope.movementInAction = movement;
			fn;

			if (
				id == '#modalDeleteMovementNew' ||
				id == '#modalDeleteMovementNewAll'
			) {
				$rootScope.getDaysDeleteTrash();
			}

			if (
				$scope.newPublicationChecked &&
				$scope.newPublicationChecked.length > 0 &&
				id == '#modalDeleteMovementNewAll'
			) {
				$scope.movementInAction = $scope.newPublicationChecked;
				for (let i = 0; i < $scope.newPublicationChecked.length; i++) {
					if (
						$scope.newPublicationChecked[i].prazos &&
						$scope.newPublicationChecked[i].prazos.length > 0
					) {
						id = $('#modalDeleteMovementWithDeadline');
					}
				}
				$scope.deleteMultiple = true;
			}

			if (
				id == '#modalDeleteMovementNew' &&
				movement &&
				movement.prazos &&
				movement.prazos.length > 0
			) {
				$scope.movementInAction = movement;
				id = $('#modalDeleteMovementWithDeadline');
				$scope.deleteMultiple = false;
			}

			setTimeout(() => {
				$(id).modal('show');
			}, 300);
		};

		$scope.closeModal = id => {
			$(id).modal('hide');
		};

		$scope.openModalDownloadMovements = file => {
			$scope.downloadMovements(file);
		};

		$scope.downloadMovements = (fileType = 'pdf') => {
			$('#modalDownload').modal('hide');
			$scope.blockDownload = true;

			const movement = $scope.movementInAction;
			const checkedItems = $scope.newPublicationChecked;

			if (!movement && !checkedItems.length)
				return notification.danger('Nenhum movimento selecionado.');

			let ids = movement
				? movement.idMovProcessoCliente
				: checkedItems.map(x => x.idMovProcessoCliente).join();

			notification.success('Download iniciado! Isso pode levar algum tempo.');

			// setTimeout(() => {
			// 	const hasUnread = movement.length
			// 		? checkedItems.some(item => !item.lido)
			// 		: !movement.lido;

			// 	if (hasUnread) $('#modalToggleAsRead').modal('show');
			// }, 200);

			const params = {
				ids,
				tipoArquivo: fileType,
				idGrupoMovimento:
					$scope.groupUserSelected && $scope.groupData
						? $scope.groupData.idGrupo
						: null
			};

			const api = 'movements';

			downloadService.serviceDownload(params, api);
			$scope.blockDownload = false;
		};

		$scope.setDeleteModal = () => {
			$scope.tituloModal = 'Deseja excluir a movimentação?';
			$scope.mensagemModal =
				' Ao excluir movimentações, você elimina todas as informações referentes a este documento. A ação de excluir é definitiva e irreversível.';
			$scope.botaoConfirmarModal = 'Sim, quero excluir a movimentação';

			if ($stateParams.type == 'andamento') {
				$scope.tituloModal = 'Deseja excluir o andamento?';
				$scope.mensagemModal =
					'Ao excluir um andamento, você elimina todas as informações referentes a este documento. A ação de excluir é definitiva e irreversível.';
				$scope.botaoConfirmarModal = 'Sim, quero excluir o andamento';
			} else if ($stateParams.type == 'publicacao') {
				$scope.tituloModal = 'Deseja excluir a publicação?';
				$scope.mensagemModal =
					'Ao excluir uma publicação, você elimina todas as informações referentes a este documento. A ação de excluir é definitiva e irreversível.';
				$scope.botaoConfirmarModal = 'Sim, quero excluir a publicação';
			}
		};

		$scope.openProcessFolder = function() {
			const queryParams = new URLSearchParams(window.location.search);
			const pasta = queryParams.get('pasta');
			const numeroProcesso = queryParams.get('numeroProcesso');
			const idProcesso = queryParams.get('idProcesso');
			const pastaProcesso = queryParams.get('pastaProcesso');

			if (!pasta || !numeroProcesso || !idProcesso || !pastaProcesso) {
				console.warn('Parâmetros ausentes:', {
					pasta,
					numeroProcesso,
					idProcesso,
					pastaProcesso
				});

				return;
			}

			// Pega a origem
			const baseUrl = window.location.origin;

			// Monta a nova URL
			const url = `${baseUrl}/inss/processos/${pasta}?numeroProcesso=${numeroProcesso}&idProcesso=${idProcesso}&pastaProcesso=${pastaProcesso}`;

			window.open(url, '_blank');
		};

		$scope.setDeleteModal();

		$scope.openModalEmail = params => {
			$scope.paramsModalEmail = params;
			$rootScope.configSendEmail.action = params;
			$rootScope.configSendEmail.route = 'movements';
			$rootScope.configSendEmail.title = 'Enviar por email';

			const el = $('#modalSendEmailComponent');

			el.modal && el.modal('show');
		};

		$scope.openModalDownload = () => {
			const el = $('#modalDownload');

			el.modal && el.modal('show');
		};

		$scope.email = '';

		/* Impressão de movimentos */

		$scope.printMovements = movement => {
			$scope.printing = true;
			$scope.printAll = true;

			if (!movement) {
				const checkedItems = $scope.newPublicationChecked;

				if (!movement && !checkedItems.length)
					return notification.danger('Nenhum movimento selecionado.');

				var ids = checkedItems.length
					? checkedItems.map(x => x.idMovProcessoCliente).join()
					: movement.idMovProcessoCliente.toString();
			}

			$http({
				...helper.http(API.downloads, 'movements'),
				params: {
					ids: ids ? ids : movement.idMovProcessoCliente,
					tipoArquivo: 'pdf',
					quebrarPaginaImpressao: false,
					idGrupoMovimento:
						$scope.groupUserSelected && $scope.groupData
							? $scope.groupData.idGrupo
							: null
				},
				responseType: 'blob',
				noCancelOnRouteChange: true
			}).then(response => {
				const { data, status } = response;

				const prevIframes = document.querySelectorAll('.__printable-pdf-frame');

				prevIframes.forEach(iframe => iframe.remove());

				if (status > 299)
					return notification.danger('Erro ao imprimir movimentações.');

				const file = new Blob([data], { type: 'application/pdf' });

				file
					.dataURL()

					.then(() => {
						const iframe = document.createElement('iframe');

						iframe.className = '__printable-pdf-frame';

						iframe.style.position = 'fixed';
						iframe.style.bottom = '-100vh';

						iframe.src = URL.createObjectURL(file);

						document.body.appendChild(iframe);

						iframe.contentWindow.focus();

						if (window.innerWidth >= 992)
							setTimeout(() => {
								iframe.contentWindow.print();
							}, 1);

						if (
							navigator.userAgent.indexOf('Firefox') !== -1 ||
							window.innerWidth < 992
						) {
							let newWindow = window.open(
								URL.createObjectURL(file),
								'name',
								'height=800,width=1000'
							);

							newWindow.focus();
							setTimeout(() => {
								newWindow.print();
							}, 2000);
						}
						$timeout(() => {
							$scope.printing = false;
							$scope.printAll = false;
						}, 300);
					})

					.finally(() => {
						$scope.movementInAction = null;
						$timeout(() => {
							$scope.printing = false;
							$scope.printAll = false;
						}, 300);
					});

				// checkedItems.forEach(movement => movement.__checked__ = false);
			});
		};

		$scope.setMovementsAsUnread = () => {
			const registros = $scope.stateParams.movements.split(',');

			$scope.markMovementAsReadOrUnread(registros, false);
		};

		$scope.getPaginationItemUrl = item => {
			return item;
			// return `root.default.movements.list${
			// 	$scope.environmentPageMov
			// }.movementsDetails({ type: "${
			// 	item.type == -1 ? 'andamento' : 'publicacao'
			// }", movementsIDs: ${item.id} })`;
		};

		$scope.formatArrayIntoString = array => {
			let finalString = '';

			array.forEach(item => {
				finalString += item + ',';
			});

			finalString = finalString.slice(0, finalString.length - 1);

			return finalString;
		};

		$scope.fetchDetails();

		$scope.returnToPreviousPage = () => {
			$state.transitionTo('root.default.initial', {
				inherit: false,
				reload: true
			});
		};

		$(window).resize(() => {
			let previousIsMobile = $scope.isMobile;

			$scope.isMobile = window.innerWidth <= 991;

			if ($scope.isMobile != previousIsMobile) {
				$scope.$apply();
			}
		});

		$scope.confirmUnlinkDeadlines = () => {
			let iDs = [];

			iDs.push(
				$rootScope.formCreatePrazo.editingAgendaEvent.idVinculoMovimento
			);

			const request = $http({
				...helper.http(API.deadlineEvents, 'desvincular'),
				method: 'PUT',
				data: {
					iDs: iDs
				},
				messageOverride: {
					success(response, notify) {
						notify.success(
							helper.getAgendaEventUnlinkSuccessMessage(
								$rootScope.formCreatePrazo.editingAgendaEvent || {}
							)
						);
					},
					error(response, notify) {
						notify.danger('A movimentação continua vinculada!');
					}
				}
			});

			request.then(() => {
				const unlinkedEventId =
					$rootScope.formCreatePrazo.editingAgendaEvent.idVinculoMovimento;

				// Keep the movement already rendered on screen. The details endpoint can
				// temporarily return an empty item immediately after unlinking, which
				// would replace the whole view and make the movement content disappear.
				($scope.movements.items || []).forEach(movement => {
					movement.prazos = (movement.prazos || []).filter(
						prazo =>
							String(prazo.idVinculoMovimento) !== String(unlinkedEventId)
					);
				});

				const movement = ($scope.movements.items || [])[0];

				$scope.displayDeadlines(movement ? movement.prazos || [] : []);
			});

			request.finally(() => {
				$('#modalUnlinkDeadlines').modal('hide');
			});

			return request;
		};

		$scope.openModalUnlinkDeadlines = prazos => {
			$rootScope.formCreatePrazo.editingAgendaEvent = {
				...helper.cloneSimpleObject(prazos)
			};

			$('#modalUnlinkDeadlines').modal('show');
		};

		$scope.getUnlinkEventTypeLabel = () => {
			const event = $rootScope.formCreatePrazo.editingAgendaEvent || {};

			return String(event.tipoEvento || 'evento').toLocaleLowerCase('pt-BR');
		};

		$scope.isUnlinkEventTypeFeminine = () =>
			String($scope.getUnlinkEventTypeLabel()).toLocaleLowerCase('pt-BR') ===
			'tarefa';

		$scope.getUnlinkEventArticle = () =>
			$scope.isUnlinkEventTypeFeminine() ? 'a' : 'o';

		$scope.getUnlinkEventReferencePreposition = () =>
			$scope.isUnlinkEventTypeFeminine() ? '\u00e0' : 'ao';

		$scope.getUnlinkEventGenderSuffix = () =>
			$scope.isUnlinkEventTypeFeminine() ? 'a' : 'o';

		$scope.getAgendaEventTypeLabel = helper.getAgendaEventTypeLabel;

		$scope.getAgendaEventCompletedMessage = (agendaEvent, completed) => {
			const nameEvent =
				agendaEvent.idTipoEventoAgenda === -2
					? 'Prazo'
					: agendaEvent.idTipoEventoAgenda === -3
					? 'Compromisso'
					: 'Tarefa';

			const isTask = nameEvent === 'Tarefa';

			const marked = isTask ? 'marcada' : 'marcado';

			const completedText = completed
				? isTask
					? 'concluída'
					: 'concluído'
				: isTask
				? 'não concluída'
				: 'não concluído';

			return `${nameEvent} ${marked} como ${completedText}`;
		};

		$scope.finishDeadline = prazo => {
			let concluido = !prazo.concluido;
			let path = concluido ? 'marcarConcluido' : 'desmarcarConcluido';

			$http({
				...helper.http(API.deadlineEvents, `${path}`),
				method: 'PUT',
				data: { ids: [prazo.id] },
				messageOverride: {
					success(response, notify) {
						notify.success(
							$scope.getAgendaEventCompletedMessage(prazo, concluido)
						);

						$timeout(() => {
							$scope.printing = false;
							$scope.updatingAgendaEvent = false;
						}, 1000);
					}
				}
			})
				.then(() => {
					$('#modalEditAgendaEventComponent').modal('hide');

					$scope.fetchDetails();

					$rootScope.formCreatePrazo.taskToEdit.processo = {};

					$scope.$resetFormValidation('editTermEvent')();
				})

				.catch(() => {
					$timeout(() => {
						$scope.printing = false;
					}, 1000);

					const { id } = prazo;
					const agendaEventIndex = prazo
						.getItems()
						.findIndex(agendaEvent => agendaEvent.id === id);

					agendaEventIndex >= 0 &&
						($scope.events.items[agendaEventIndex] = {
							...prazo,
							concluido
						});
				});
		};

		$scope.toggleImportant = agendaEvent => {
			$scope.updateAgendaEvent(
				{
					...agendaEvent,
					importante: !agendaEvent.importante
				},
				!agendaEvent.importante
					? 'Prazo marcado como importante!'
					: 'Prazo desmarcado como importante!',
				'edit'
			);
		};

		$scope.updateAgendaEvent = (agendaEvent, type, typeUpdate) => {
			$scope.printing = true;

			if (agendaEvent._hora === '') {
				agendaEvent._hora = '00:00';
			}

			const { _dia, _hora, ...event } = agendaEvent;

			let finalDate;

			if (_dia && _hora) {
				const eventDate = `${_dia.substr(3, 2)}-${_dia.substr(
					0,
					2
				)}-${_dia.substr(6)}`;

				const initialDay = parseInt(_dia.substr(0, 2));
				const initialMonth = parseInt(_dia.substr(3, 2)) - 1;
				const initialYear = parseInt(_dia.substr(6));
				const initialHour = parseInt(_hora.substr(0, 2));
				const initialMinute = parseInt(_hora.substr(3, 2));

				// event.dataHoraInicio = new Date(`${eventDate} ${_hora}`);
				event.dataHoraInicio = new Date(
					initialYear,
					initialMonth,
					initialDay,
					initialHour,
					initialMinute
				);

				const hour = parseInt(_hora.substr(0, 2), 10);

				finalDate = new Date(initialYear, initialMonth, initialDay);

				finalDate.setHours(
					(Number.isNaN(hour) ? event.dataHoraInicio.getHours() : hour) + 1,
					_hora.substr(3, 2)
				);

				let dataHoraFinal = new Date(`${eventDate} ${_hora}`);

				// aqui
				if (event.diaInteiro) {
					event.dataHoraInicio.setHours(0, 0, 0, 0);
					dataHoraFinal = new Date(finalDate).setHours(23, 59, 0, 0);

					event.dataHoraInicio = moment(
						new Date(event.dataHoraInicio).setHours(0, 0)
					).format('YYYY-MM-DDTHH:mm:ss');

					if (hour >= 23)
						event.dataHoraFim = moment(
							new Date(event.dataHoraFim).setHours(23, 59)
						).format('YYYY-MM-DDTHH:mm:ss');
					else
						event.dataHoraFim = moment(dataHoraFinal).format(
							'YYYY-MM-DDTHH:mm:ss'
						);
				} else {
					event.dataHoraInicio = moment(event.dataHoraInicio).format(
						'YYYY-MM-DDTHH:mm:ss'
					);

					if (hour >= 23)
						event.dataHoraFim = moment(
							new Date(event.dataHoraInicio).setHours(23, 59)
						).format('YYYY-MM-DDTHH:mm:ss');
					else
						event.dataHoraFim = moment(
							new Date(event.dataHoraInicio).setHours(
								new Date(event.dataHoraInicio).getHours() + 1
							)
						).format('YYYY-MM-DDTHH:mm:ss');

					// event.dataHoraFim = finalDate.toJSON();
				}
			}

			const checkbox = document.querySelector(
				'#modalEditAgendaEventComponent #edit-sincronizado'
			);

			if (checkbox) {
				//O valor do 'edit-Sincronizado' sempre representa o inverso do que está no checkbox
				event.sincronizado = !document.querySelector(
					'#modalEditAgendaEventComponent #edit-sincronizado'
				).checked;
			}

			if (
				moment(event.dataHoraInicio).isBefore(moment().format('YYYY/MM/DD')) &&
				$state.params.filtro == 'vencidos' &&
				event.sincronizado
			) {
				notification.danger(
					'Data de início deve ser igual ou superior ao dia de hoje!'
				);

				$scope.printing = false;

				$('#modalEditAgendaEventComponent').modal('hide');

				$rootScope.formCreatePrazo.taskToEdit.processo = {};

				$scope.$resetFormValidation('editTermEvent')();

				$scope.truncatedText();

				return false;
			}

			if (typeUpdate !== 'edit') {
				event.observacao = $rootScope.configQuill.value;
			}

			$scope.request = () =>
				$http({
					...helper.http(API.deadlineEvents, 'PUT'),
					data: { itens: [event] },
					messageOverride: {
						success(response, notify) {
							let idTipoEventoAgenda = -3;

							if (
								response &&
								response.data &&
								response.data.itens &&
								response.data.itens[0] &&
								response.data.itens[0].idTipoEventoAgenda
							) {
								idTipoEventoAgenda = response.data.itens[0].idTipoEventoAgenda;
							}

							let nameType =
								idTipoEventoAgenda == -3
									? 'Compromisso'
									: idTipoEventoAgenda == -1
									? 'Tarefa'
									: 'Prazo';

							if (type === 'edit') {
								notify.success(
									`${nameType} editad${
										idTipoEventoAgenda == -1 ? 'a' : 'o'
									} com sucesso.`
								);
							} else if (type === 'done' && agendaEvent.concluido === false) {
								notify.success(
									$scope.getAgendaEventCompletedMessage(agendaEvent, false)
								);
							} else if (type === 'done' && agendaEvent.concluido === true) {
								notify.success(
									$scope.getAgendaEventCompletedMessage(agendaEvent, true)
								);
							} else if (type != 'edit' && type != 'done') {
								notify.success(type);
							}

							$timeout(() => {
								$scope.printing = false;
								$scope.updatingAgendaEvent = false;
							}, 1000);
						},
						error(response, notify) {
							let idTipoEventoAgenda = -3;

							if (
								response &&
								response.data &&
								response.data.itens &&
								response.data.itens[0] &&
								response.data.itens[0].idTipoEventoAgenda
							) {
								idTipoEventoAgenda = response.data.itens[0].idTipoEventoAgenda;
							}

							let nameType =
								idTipoEventoAgenda == -3
									? 'Compromisso'
									: idTipoEventoAgenda == -1
									? 'Tarefa'
									: 'Prazo';

							notify.success(
								`${nameType} não ${
									type === 'done'
										? `concluíd${idTipoEventoAgenda == -1 ? 'a' : 'o'}`
										: `editad${idTipoEventoAgenda == -1 ? 'a' : 'o'}`
								}!`
							);

							$scope.updatingAgendaEvent = false;
							$timeout(() => {
								$scope.printing = false;
								$scope.updatingAgendaEvent = false;
							}, 1000);
						}
					}
				})
					.then(() => {
						$('#modalEditAgendaEventComponent').modal('hide');

						$scope.fetchDetails();

						$rootScope.formCreatePrazo.taskToEdit.processo = {};

						$scope.$resetFormValidation('editTermEvent')();
					})

					.catch(() => {
						$timeout(() => {
							$scope.printing = false;
						}, 1000);

						const { id } = agendaEvent;
						const agendaEventIndex = $scope.events
							.getItems()
							.findIndex(agendaEvent => agendaEvent.id === id);

						agendaEventIndex >= 0 &&
							($scope.events.items[agendaEventIndex] = {
								...agendaEvent,
								concluido: agendaEvent.concluido
							});
					});

			if (event.sincronizado && !$rootScope.noSync) {
				if (agendaEvent.eventoGoogleId === 'true')
					delete agendaEvent.eventoGoogleId;

				let isInsert = Boolean(agendaEvent.eventoGoogleId);

				if (!isInsert && event.sincronizado) {
					//criar um evento na agenda
					integracaoGoogleCalendar.insertGoogleEvent(
						event,
						null,
						null,
						type,
						$scope.request
					);
				} else if ($state.params.filtro == 'vencidos' && event.eventoGoogleId) {
					//Excluir se for vencido
					integracaoGoogleCalendar.deleteGoogleEvent(event);

					setTimeout(() => {
						delete event.eventoGoogleId;

						integracaoGoogleCalendar.insertGoogleEvent(
							event,
							null,
							null,
							type,
							$scope.request
						);
					});
				} else {
					//atualizar evento ja existente
					integracaoGoogleCalendar.updateGoogleEvent(event, $scope.request);
				}
			} else {
				//atualizar apenas no sistema advise
				event.sincronizado = false;

				$scope.request();
			}
		};

		$scope.goToSchedule = prazo => {
			if (prazo && prazo.id) {
				$http({
					...helper.http(API.deadlineEvents, 'GET'),
					params: {
						ids: prazo.id,
						ativo: true,
						paginaAtual: 1,
						registrosPorPagina: 10,
						campos: '*',
						ordenacao: '-diaInteiro,+dataHoraInicio'
					}
				}).then(response => {
					const { itens = [] } = response.data;

					if (itens && itens[0]) {
						localStorage.setItem(
							'__FORCE_OPEN_DETAILS__',
							JSON.stringify(itens[0])
						);

						const url = $state.href(
							'root.default.module-schedule',
							{},
							{
								absolute: true,
								inherit: false
							}
						);

						window.open(url, '_blank');
					}
				});

				return;
			}
		};

		$scope.modalSchedule = open => {
			$scope.overMenuSchedule = open;
		};

		$scope.getData = function(event) {
			function formatTitleDate(dateValue) {
				var date = new Date(dateValue);

				if (isNaN(date.getTime())) {
					return '';
				}

				var formattedDate = moment(date)
					.locale('pt-br')
					.format('dddd, D [de] MMMM [de] YYYY');

				return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
			}
			function formatHour(dateValue) {
				var date = new Date(dateValue);

				var hours = date.getHours();
				var minutes = date.getMinutes();

				hours = hours < 10 ? '0' + hours : hours;
				minutes = minutes < 10 ? '0' + minutes : minutes;

				return hours + ':' + minutes;
			}

			function getHour() {
				if (event.diaInteiro) {
					return event.remoto || event.presencial ? 'Dia todo' : '(Dia todo)';
				}

				return formatHour(event.dataHoraInicio);
			}

			function getEndHour() {
				if (event.diaInteiro) {
					return '';
				}

				return formatHour(event.dataHoraFim);
			}

			function getPresencialRemoto() {
				if (event.presencial) {
					return ' (Presencial)';
				}

				if (event.remoto) {
					return ' (Remoto)';
				}

				return '';
			}

			var endHour = getEndHour();

			var endText =
				formatTitleDate(event.dataHoraInicio) +
				' · ' +
				getHour() +
				(endHour ? ' às ' + endHour : '') +
				getPresencialRemoto();

			return endText;
		};

		$scope.editTerm = async contentTerm => {
			let dataSync = {};

			//Recupera dados de sincronização
			dataSync = integracaoGoogleCalendar.recoverInfos();

			//aqui google agenda
			if (!dataSync) await integracaoGoogleCalendar.permissionIntegracao();

			//Recupera os dados de sincronização
			dataSync = integracaoGoogleCalendar.recoverInfos();

			$rootScope.sincronizacaoError = dataSync.error == true ? true : false;

			if (!$rootScope.sincronizacaoError) {
				$scope.eventsTypes.getItems().length === 0 &&
					$scope.recordEventsTypes($scope.eventsTypes);

				$rootScope.formCreatePrazo.editingAgendaEvent = {
					...helper.cloneSimpleObject(contentTerm),
					_dia: moment(contentTerm.dataHoraInicio).format('DD/MM/YYYY'),
					_hora: moment(contentTerm.dataHoraInicio).format('HH:mm'),
					_horaFim: contentTerm.diaInteiro
						? '00:00'
						: moment(contentTerm.dataHoraFim).format('HH:mm')
				};

				if (
					contentTerm.idProcesso &&
					contentTerm.numeroProcesso &&
					$rootScope.formCreatePrazo &&
					$rootScope.formCreatePrazo.editingAgendaEvent
				) {
					$rootScope.formCreatePrazo.editingAgendaEvent.processo = {
						id: contentTerm.idProcesso,
						nome: contentTerm.numeroProcesso,
						fixado: true
					};
				}

				$rootScope.formCreatePrazo.idTipoCompromisso =
					contentTerm.idTipoEventoAgenda;

				$rootScope.formCreatePrazo.editingAgendaEvent.sincronizado = $rootScope
					.formCreatePrazo.editingAgendaEvent.eventoGoogleId
					? true
					: false;

				$rootScope.formCreatePrazo.editingAgendaEvent.dataCurtaFormatada = moment(
					$rootScope.formCreatePrazo.editingAgendaEvent.dataHoraInicio
				).format('DD/MM/YYYY');

				$('#modalEditAgendaEventComponent').modal('show');

				$rootScope.initQuillEdit(
					$rootScope.formCreatePrazo.editingAgendaEvent.observacao,
					'edit'
				);
			} else {
				$('#modalDisabledGoogleCalendarError').modal('show');

				contentTerm.sincronizado = false;

				$scope.guardDataPrazos = {
					func: contentTerm,
					modal: 'edit'
				};
			}
		};

		// VISUALIZAR PRAZOS

		function rearrangeDeadline(a, b) {
			if (a.concluido && !b.concluido) {
				return 1;
			} else if (!a.concluido && b.concluido) {
				return -1;
			} else {
				return 0;
			}
		}

		let itemsPerPage = 3;
		let currentPage = 0;

		$scope.textButton = 'Exibir mais +';

		$scope.displayDeadlines = deadline => {
			const start = currentPage;
			const end = itemsPerPage;

			$scope.objetosExibidos = deadline.slice(start, end);

			currentPage = 0;

			setTimeout(() => {
				$scope.trustAsHtml();
			}, 500);
		};

		$scope.trustAsHtml = function() {
			$scope.objetosExibidos.forEach((prazo, indexOf) => {
				let element = document.getElementById(`observation-${indexOf}`);

				if (element)
					element.innerHTML = prazo.observacao
						? prazo.observacao
						: 'Nenhuma Observação';
			});
		};

		$scope.toggleVisibility = deadline => {
			if ($scope.objetosExibidos.length > 3) {
				itemsPerPage = 3;
				currentPage = 0;
				$scope.displayDeadlines(deadline);

				$scope.textButton = 'Exibir mais +';
			} else {
				itemsPerPage = deadline.length;
				currentPage = 0;
				$scope.displayDeadlines(deadline);
				$scope.textButton = 'Exibir menos -';
			}
		};

		// Ações Mobile
		$scope.actionsMobile = (mov, i) => {
			if (!mov.acao) {
				$scope.movements.items.forEach((m, index) => {
					if (m.acao) {
						m.acao = false;
						$scope.actionElementsMobile('close', index);
					}
				});

				mov.acao = true;

				$scope.actionElementsMobile('open', i);
				$scope.closeActionMobile();
			} else {
				mov.acao = false;
				$scope.actionElementsMobile('close', i);
			}
		};

		/** Método que fecha filtro de tribunais personalidado */
		$scope.closeActionMobile = () => {
			$(document).on('click', function(e) {
				if (!$(e.target).is('.card__action-mobile')) {
					if ($scope.openCardAction) {
						var i = 0;

						$scope.movements.items.forEach((m, index) => {
							if (m.acao) {
								m.acao = false;
								i = index;
							}
						});

						$scope.actionElementsMobile('close', i);
					}
				}
			});
		};

		$scope.actionElementsMobile = (action, i) => {
			let element = document.getElementById(`action-mobile${i}`);
			let more = document.getElementById(`more-mobile${i}`);
			let close = document.getElementById(`close-mobile${i}`);

			element.style.display = action == 'open' ? 'block' : 'none';

			action == 'open'
				? ((more.style.display = 'none'), (close.style.display = 'block'))
				: ((close.style.display = 'none'), (more.style.display = 'block'));

			$scope.openCardAction = action == 'open' ? true : false;
		};

		$scope.closeAllMovements = () => {
			$scope.movements.items.forEach((m, index) => {
				if (m.acao) {
					m.acao = false;
					$scope.actionElements('close', index);
					$scope.actionElementsMobile('close', index);
				}
			});
		};

		/** Permissão Criar Prazo */
		$scope.permissionsUserClient = () => {
			$http({
				...helper.http(API.permissions, 'GET'),
				params: {
					...helper.httpFields([
						'idFuncionalidade',
						'idUsuarioClienteXFuncionalidade'
					]),
					registrosPorPagina: -1,
					ativo: true
				}
			}).then(response => {
				for (let index = 0; index < response.data.itens.length; index++) {
					if (response.data.itens[index].idFuncionalidade == -23) {
						$scope.permissionGoogleCalendar = true;
					}
				}
			});
		};

		/** Método que fica observando se modal de prazos foi fechado
		 *  para resetar form do modal
		 */
		$('#modalCreateAgendaEventComponent').on('hide', () => {
			$rootScope.formCreatePrazo.taskToEdit.processo = {};

			return $scope.$resetFormValidation('createEvent')();
		});

		/** Método para trazer os registros da agenda */
		$scope.recordAgendas = responseStore => {
			const idUsuarioCliente =
				parseInt(authentication.getUserData('idUsuarioCliente'), 10) ||
				undefined;

			$http({
				...helper.http(API.agendas, 'GET'),
				params: {
					...helper.httpFields(['id']),
					idUsuarioCliente: idUsuarioCliente
				}
			}).then(response => responseStore.setItems(response.data.itens));
		};

		/** Método para verificar os tipos de eventos na agenda */
		$scope.recordEventsTypes = responseStore => {
			const idCliente =
				parseInt(authentication.getUserData('idCliente'), 10) || undefined;

			$http({
				...helper.http(API.eventsTypes, 'GET'),
				params: {
					...helper.httpFields(['id,nome']),
					idCliente,
					ativo: true
				}
			}).then(({ data }) => {
				responseStore.setItems(data.itens);

				// Converte o array para uma string e armazena no Session Storage
				sessionStorage.setItem(
					'__EVENTS_TYPES__',
					JSON.stringify(responseStore.getItems())
				);

				$scope.typesOfEevents = responseStore.setItems(data.itens);

				$rootScope.formCreatePrazo.eventsTypes = responseStore;

				$scope.selectedType = data.itens.find(item => item.nome == 'Prazo');
			});
		};

		// /** Verifica as permições do usuário */
		// permissions
		// 	.loadPermissions()
		// 	.then(async () => {
		// 		if (blocked !== 'true') {
		// 			/** Ações no carregamento da pág */
		// 			!$scope.palavraChaveSelecionada.length && $scope.keywordsAll();
		// 			!$scope.keyWordAccount && $scope.keywordPubliGeneral();
		// 			!$scope.diaryAccount && $scope.diaryGeneral();

		// 			if (!location.pathname.includes('detalhes')) {
		// 				$scope.publicationPermission = permissions.has(
		// 					'recordPublications'
		// 				);

		// 				$scope.movementPermission = permissions.has('createMovements');

		// 				$scope.showVideo =
		// 					!$scope.publicationPermission && !$scope.movementPermission;

		// 				$scope.allOfAccount = !!!$stateParams.pasta;

		// 				if ($scope.publicationPermission || $scope.movementPermission) {
		// 					await $scope.recordParametersUsers();
		// 					$scope.recordBriefcase($scope.briefcase);
		// 				}
		// 			}
		// 		}
		// 	})
		// 	.finally(() => {
		// 		$scope.loadingPage = false;
		// 		$scope.loadingSide = false;
		// 	});

		/** Integração com a agenda */
		$scope.agendaEventDefault = {
			title: '',
			address: '',
			initialHour: '',
			wholeDay: false,
			eventTypeId: '',
			initialDate: '',
			observation: '',
			reminderTypeId: '',
			finalRecurrenceDate: '',
			recurringEventTypeId: ''
		};

		$scope.agendaEvent = helper.cloneSimpleObject($scope.agendaEventDefault);

		$rootScope.formCreatePrazo.getEventComponent = () => {
			setTimeout(() => {
				window.location.reload();
			}, 1000);
		};

		/** prepara registro para criação de vento evento vinculando
		 * movimento na agenda
		 */
		$scope.createAgendaEvent = async form => {
			$rootScope.creationEventLoading = true;

			//Recupera dados de sincronização
			let dataSync = integracaoGoogleCalendar.recoverInfos();

			$scope.googleSync = dataSync.sincronizado;

			const fields = [
				'titulo',
				'dataHora',
				'dataHoraInicio',
				'diaInteiro',
				'idLembrete',
				'idOpcaoLembreteAgenda',
				'idRepetEventoAgenda',
				'localizacao',
				// 'observacao',
				'idTipoEventoAgenda',
				'idMovProcessoCliente',
				'sincronizado'
			];

			let [
				titulo,
				dataHora = `${new Date().getHours()}:30`,
				dataHoraInicio = new Date().toLocaleDateString('pt-BR'),
				diaInteiro,
				idOpcaoLembreteAgenda = $rootScope.formCreatePrazo &&
				$rootScope.formCreatePrazo.idNotificacaoCompromisso
					? $rootScope.formCreatePrazo.idNotificacaoCompromisso
					: -1,
				idRepetEventoAgenda = -1,
				localizacao,
				idProcesso,
				// observacao,
				idTipoEventoAgenda,
				idMovProcessoCliente,
				idTipoCompromisso,
				eventoGoogleId,
				sincronizado
			] = fields.map(input => $scope.getScopedInputValue(form[input]));

			if (form['localizacao']) {
				localizacao = $scope.getScopedInputValue(form['localizacao']);
			}

			if (
				$rootScope.formCreatePrazo &&
				$rootScope.formCreatePrazo.taskToEdit &&
				$rootScope.formCreatePrazo.taskToEdit.processo
			) {
				idProcesso =
					$rootScope.formCreatePrazo.taskToEdit.processo.idProcesso || null;
			}

			const endHour = $scope.getScopedInputValue(form.dataHoraFim);

			let importante, remoto, presencial;

			if (form && form['importante']) {
				importante =
					form['importante'].$viewValue || form['importante'].$modelValue;
			}

			if (form && form['presencial']) {
				presencial =
					form['presencial'].$viewValue || form['presencial'].$modelValue;
			}

			if (form && form['remoto']) {
				remoto = form['remoto'].$viewValue || form['remoto'].$modelValue;
			}

			const eventDate = `${dataHoraInicio.substr(3, 2)}-${dataHoraInicio.substr(
				0,
				2
			)}-${dataHoraInicio.substr(6)}`;

			let fixDate = eventDate.replace('-', '/').replace('-', '/');

			const initialDate =
				diaInteiro === true
					? new Date(`${fixDate}`).setHours(0, 0, 0)
					: new Date(`${fixDate} ${dataHora}`);

			if (diaInteiro == true || dataHora == '') {
				dataHora = '23:59:59';
			}

			const finalDate = new Date(`${fixDate} ${dataHora}`);

			const HoraAtual = new Date();

			HoraAtual.setHours(HoraAtual.getHours());

			const hour = parseInt(dataHora.substr(0, 2), 10);

			if (hour >= 23) finalDate.setHours(23, 59);
			else if (diaInteiro) {
				finalDate.setHours(23, 59);
			} else {
				finalDate.setHours(endHour.substr(0, 2), endHour.substr(3, 2));
			}

			if (!$scope.validationHours(initialDate, finalDate, form)) return;

			const checkbox = document.querySelector(
				'#modalCreateAgendaEvent #sincronizado'
			);

			if (checkbox) {
				//O valor do 'edit-Sincronizado' sempre representa o inverso do que está no checkbox
				sincronizado = checkbox.checked;
			}

			const event = {
				titulo,
				dataHoraInicio: moment(initialDate).format('YYYY-MM-DDTHH:mm:ss'),
				dataHoraFim: moment(finalDate).format('YYYY-MM-DDTHH:mm:ss'),
				idAgenda: $rootScope.idAgenda
					? $rootScope.idAgenda
					: $scope.agendas.getItems()[0].id,
				diaInteiro,
				idOpcaoLembreteAgenda,
				idRepetEventoAgenda,
				importante,
				localizacao,
				idProcesso,
				observacao: $rootScope.formCreatePrazo.taskToEdit.observacao,
				idTipoEventoAgenda: idTipoEventoAgenda
					? idTipoEventoAgenda
					: idTipoCompromisso,
				idCategoriaEventoAgenda:
					Number(idTipoCompromisso) === -3
						? $rootScope.formCreatePrazo.taskToEdit.idCategoriaEventoAgenda
						: undefined,
				eventoGoogleId,
				sincronizado: $scope.googleSync ? !sincronizado : false,
				idsMovProcessosVinculados: [
					{
						idMovProcessoCliente: idMovProcessoCliente
							? idMovProcessoCliente
							: $scope.movementInAction.items[0].idMovProcessoCliente
					}
				],
				remoto,
				presencial
			};

			if (event.sincronizado) {
				await integracaoGoogleCalendar.insertGoogleEvent(event, fields, form);
				setTimeout(() => {
					$scope.fetchDetails();
					$rootScope.formCreatePrazo.taskToEdit.processo = {};
					$scope.$resetFormValidation('createEvent')();
				}, 500);
			} else {
				delete event['eventoGoogleId'];

				$scope.sendEvent(event, fields, form);
			}
		};

		/** Cria evento de agenda com movimento */
		$scope.sendEvent = (event, fields, form) => {
			return $http({
				...helper.http(API.deadlineEvents, 'POST'),
				data: { itens: [event] },
				messageOverride: {
					success(response, notify) {
						let idTipoEventoAgenda = -3;

						if (
							response &&
							response.data &&
							response.data.itens &&
							response.data.itens[0] &&
							response.data.itens[0].idTipoEventoAgenda
						) {
							idTipoEventoAgenda = response.data.itens[0].idTipoEventoAgenda;
						}

						let nameType =
							idTipoEventoAgenda == -3
								? 'Compromisso'
								: idTipoEventoAgenda == -1
								? 'Tarefa'
								: 'Prazo';

						notify.success(
							`${nameType} cadastrad${
								idTipoEventoAgenda == -1 ? 'a' : 'o'
							} com sucesso.`
						);
					}
				}
			})
				.then(() => {
					$scope.fetchDetails();

					fields.map(inputKey =>
						helper.defer(() => {
							const $control = form[inputKey];

							if ($control) {
								switch (inputKey) {
									case 'idRepetEventoAgenda':
									case 'idOpcaoLembreteAgenda':
										$control.$setViewValue(-1);
										break;
									case 'idTipoCompromisso':
										$control.$setViewValue('');
										$control.$$ngModelSet('');
										$control.$$setModelValue('');
										break;
									case 'diaInteiro':
										$control.$setViewValue(false);
										$control.$$ngModelSet(false);
										$control.$$setModelValue(false);
										break;
									case 'dataHoraInicio':
										$control.$setViewValue(moment().format('DD/MM/YYYY'));
										break;
									case 'idTipoEventoAgenda':
									case 'idMovProcessoCliente':
										break;
									default:
										$control.$setViewValue('');
										break;
								}

								$control.$render();
							}
						})
					);

					$rootScope.formCreatePrazo.taskToEdit.processo = {};
					$scope.$resetFormValidation('createEvent')();

					$('#modalCreateAgendaEventComponent').modal('hide');
				})
				.finally(() => ($rootScope.creationEventLoading = false));
		};

		$scope.closeModal = () => {
			$('.modal').modal('hide');
		};

		$scope.validationHours = (sDate, eDate) => {
			const startDate = moment(sDate);
			const endDate = moment(eDate);

			if (!startDate.isValid() || !endDate.isValid()) {
				notification.danger('Informe horários válidos para o compromisso.');

				$rootScope.creationEventLoading = false;

				return false;
			}

			if (endDate.isSameOrBefore(startDate)) {
				notification.danger(
					'Hora final cadastrada no compromisso não pode ser menor ou igual à hora inicial!'
				);

				$rootScope.creationEventLoading = false;

				return false;
			}

			const diffInMinutes = endDate.diff(startDate, 'minutes');

			if (diffInMinutes < 15) {
				notification.danger(
					'O intervalo mínimo entre o horário de início e fim é de 15 minutos.'
				);

				$rootScope.creationEventLoading = false;

				return false;
			}

			return true;
		};

		$scope.recordIntegration = async () => {
			//Recupera dados de sincronização
			$scope.dataSync = integracaoGoogleCalendar.recoverInfos();
			//aqui google agenda
			if (!$scope.dataSync)
				await integracaoGoogleCalendar.permissionIntegracao();
			//Recupera os dados de sincronização
			$scope.dataSync = integracaoGoogleCalendar.recoverInfos();
			$rootScope.sincronizacaoError =
				$scope.dataSync && !!$scope.dataSync.error;
			if ($scope.dataSync && $scope.dataSync.sincronizado) {
				$rootScope.emailGoogleAccount = true;
				$rootScope.emailGoogle = $scope.dataSync.email;
				$scope.sync = true;
			} else {
				$rootScope.emailGoogleAccount = $rootScope.sincronizacaoError
					? true
					: false;
				$rootScope.emailGoogle = false;
			}
			if ($rootScope.sincronizacaoError)
				$('#modalDisabledGoogleCalendarError').modal('show');
		};

		$scope.recordIntegration();

		$timeout(() => {
			$('#modalRecoverPastDeadlinesOneComponent').on(
				'hidden.bs.modal',
				function() {
					if ($rootScope.recoverPastDeadlinesClosingFromChoice) {
						$scope.sync = false;

						return;
					}

					if ($rootScope.formCreatePrazo.modalOpen == 'modalSync') {
						$('#modalSyncAgenda').modal('show');
					} else if ($rootScope.formCreatePrazo.modalOpen == 'modalCreate') {
						$('#modalCreateAgendaEventComponent').modal('show');
					}
					$scope.sync = false;
				}
			);
		}, 5000);

		$scope.removeSearchIcon = () => {
			if ($scope.verifySearch == true) {
				$scope.searchIcon = true;
			}
		};

		$scope.searchTextual = event => {
			let el1 = document.getElementById('pesqDetails');

			var nome = el1.value.trim();
			var nomeLenghtSpacesShort = nome.replace(/\s/g, '').length;
			var nomeLenghtSpaces = nome.length;

			if (nomeLenghtSpacesShort < 3 && event != 'blur' && el1.value != '') {
				el1.classList.add('search__input-invalid');
				$scope.popover = true;
				$scope.invalidName = true;
				$scope.popoverMax = false;
			} else if (nomeLenghtSpaces >= 301) {
				el1.classList.add('search__input-invalid');
				$scope.popover = true;
				$scope.invalidName = true;
				$scope.popoverMax = true;
			} else {
				$scope.popover = false;
				event != 'blur' && el1.classList.remove('search__input-invalid');
			}

			if (!el1.classList.contains('search__input-invalid'))
				$scope.invalidName = false;

			if (event == 'blur') $scope.popover = false;
		};

		$scope.handleSearch = (filter, clear) => {
			if (filter) {
				var nome = filter.trim();
				var nomeLenghtSpacesShort = nome.replace(/\s/g, '').length;
				var nomeLenghtSpaces = nome.length;

				if (
					(nomeLenghtSpacesShort < 3 && filter != '') ||
					nomeLenghtSpaces >= 301
				) {
					$scope.searchTextual();
					document.getElementById('pesqDetails').focus();

					return;
				}
			}

			$scope.stateParams.titulo = filter;

			$scope.stateParams.paginaAtual = 1;

			if (clear) $scope.stateParams.titulo = '';

			if (!!$scope.stateParams.titulo) {
				$scope.searchIcon = false;
				$scope.verifySearch = true;
			}

			$state.go('root.default.movements.inssDetails', $scope.stateParams, {
				inherit: false
			});
		};

		/** verifica se esta sincronizado com o google agenda */
		$scope.checkSyncDeadlines = async (fn, movement, type) => {
			if ($scope.idProcesso && $scope.numeroProcesso) {
				$scope.processoEvento = {
					id: $scope.idProcesso,
					nome:
						($scope.inssProcessHeader &&
							$scope.inssProcessHeader.pastaUsuarioCliente) ||
						movement.pasta ||
						$scope.numeroProcesso,
					fixado: true
				};

				$rootScope.formCreatePrazo.taskToEdit.processo = {
					...$scope.processoEvento
				};
			}

			$scope.closeAllMovements();

			//Recupera dados de sincronização
			let dataSync = integracaoGoogleCalendar.recoverInfos();

			//aqui google agenda
			if (!dataSync) await integracaoGoogleCalendar.permissionIntegracao();

			//Recupera os dados de sincronização
			dataSync = integracaoGoogleCalendar.recoverInfos();

			$rootScope.sincronizacaoError = dataSync.error == true ? true : false;

			if (!$rootScope.sincronizacaoError) {
				//Variavel que guarda se ta sincronizado ou não
				$scope.googleSync = dataSync.sincronizado;
				//Guarda intimação a ser vinculada com prazo
				$scope.movementInAction = movement;

				if (
					$scope.movementInAction &&
					$scope.movementInAction.items &&
					$scope.movementInAction.items[0] &&
					$scope.movementInAction.items[0].idMovProcessoCliente
				) {
					$rootScope.formCreatePrazo.idsMovProcessosVinculados = [
						{
							idMovProcessoCliente:
								$scope.movementInAction.items[0].idMovProcessoCliente
						}
					];
				} else {
					$rootScope.formCreatePrazo.idsMovProcessosVinculados = [
						{
							idMovProcessoCliente: movement.idMovProcessoCliente
						}
					];
				}

				//Variavel que guarda se ta sincronizado ou não, de forma geral '$rootScope'
				$rootScope.noSync = !dataSync.sincronizado ? true : false;

				$rootScope.formCreatePrazo.idTipoCompromisso = type;

				//Verifica se e para mostrar mensagem de sincronização
				const showMessage = !integracaoGoogleCalendar.notAgainSincGoogleAgenda();

				if (!$scope.googleSync && showMessage)
					$('#modalSyncAgenda').modal('show');
				else {
					$scope.modalAddEvent(type);

					fn(movement);
				}
			} else {
				$('#modalDisabledGoogleCalendarError').modal('show');

				$scope.guardDataPrazos = {
					func: fn,
					mov: movement
				};
			}

			$scope.modalSchedule(false);
		};

		//Dessincroniza quando da erro na sincronização
		$scope.disconnectSyncError = async () => {
			$scope.loadingDisconnectError = true;

			let dataSync = integracaoGoogleCalendar.recoverInfos();

			await integracaoGoogleCalendar.disconnectSync(
				dataSync.idAgendaGoogleCalendar
			);

			$('#modalDisabledGoogleCalendarError').modal('hide');

			$scope.loadingDisconnectError = false;
			$rootScope.sincronizacaoError = false;

			$scope.checkSyncDeadlines(
				$scope.guardDataPrazos.func,
				$scope.guardDataPrazos.mov
			);
		};

		/************* METODO PARA PASSAR EVENTO PRA SINCRONIZADO *************/
		$scope.modalAddEvent = type => {
			$rootScope.formCreatePrazo.taskToEdit.sincronizado = $rootScope.noSync;
			$rootScope.formCreatePrazo.idTipoCompromisso = Number(type) || void 0;
		};
		/******************************** FIM ********************************/

		$scope.checkGoogleSync = () => ($scope.googleSync = true);

		$scope.showAgain = localStorage.getItem('showSyncMessage') || true;

		/** Abre modal de criação de agenda */
		$scope.openCreateAgendaEventModal = movement => {
			if (
				// permissions.has('recordSchedule') &&
				$scope.agendas.items.length === 0 &&
				$scope.eventsTypes.items.length === 0
			) {
				!$rootScope.idAgenda && $scope.recordAgendas($scope.agendas);
				$scope.recordEventsTypes($scope.eventsTypes);
			}
			$scope.movementsPrazo = { ...movement };
			$('#modalCreateAgendaEventComponent').modal('show');

			$rootScope.formCreatePrazo.taskToEdit.processo = {
				...$scope.processoEvento
			};
		};

		$scope.returnResume = resume => {
			const str = resume;
			var termo = $scope.stateParamsFilter.pesquisa;

			if (!termo) return resume;

			let str2 = str
				.toLowerCase()
				.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '');
			let termo2 = termo
				.toLowerCase()
				.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '');

			function hasInclude() {
				if (str2.includes(termo2)) return true;
				else return false;
			}

			if (!hasInclude()) {
				for (let index = 0; termo.length > 0; index++) {
					const ultima = termo.substring(termo.lastIndexOf(' ') + 1);

					termo = termo.substring(0, termo.length - ultima.length - 1);

					if (hasInclude()) break;
				}

				if (!hasInclude()) return resume;
			}

			if (!hasInclude()) return resume;

			var positionInitial = str2.indexOf(termo2);

			var output = [
				str.slice(0, positionInitial),
				'<span class="termResume">',
				str.slice(positionInitial)
			].join('');

			let output2 = output
				.toLowerCase()
				.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '');

			var positionEnd = output2.indexOf(termo2) + termo.length;

			output = [
				output.slice(0, positionEnd),
				'</span>',
				output.slice(positionEnd)
			].join('');

			return output;
		};

		$scope.changePage = item => {
			if (!item) return;

			const stateWithParams = $scope.getPaginationItemUrlMovementsINSS(item);
			const m = /^([^(]+)\((.*)\)$/.exec(stateWithParams);

			const name = m ? m[1].trim() : stateWithParams.trim();
			const params = m ? $scope.$eval(m[2]) : {};

			$state.go(name, params, { inherit: true });
		};

		$scope.onInit();
	}
]);

export default controller;
